// extracted by mini-css-extract-plugin
export default {"cls1":"UserTaggingPingBodyStyles-cls1__bfc9275a29a54ac506ad","cls2":"UserTaggingPingBodyStyles-cls2___4b24443b36bb03d2934 UserTaggingPingBodyStyles-cls1__bfc9275a29a54ac506ad"};